module.exports = __webpack_public_path__ + "img/e2f54fa2f99cb3f74edb624052cf382d.png";